//
// Autoplay Controller

autoplayController = function () {
  var _limitPopupOpen = false;
  var _readyToStart = false;

  this.timeToNextAutoplay = 500;

  this.initialise = function (json) {
    this.lossLimitTranslationPhrase = json.lossLimitTranslationPhrase;
    this.winLimitTranslationPhrase = json.winLimitTranslationPhrase;
    this.insufficientCreditTranslationPhrase =
      json.insufficientCreditTranslationPhrase;
    this.defaultTranslationPhrase = json.defaultTranslationPhrase;

    if (checkForUndefined(this.lossLimitTranslationPhrase))
      console.log("lossLimitTranslationPhrase undefined in autoplayController");
    if (checkForUndefined(this.winLimitTranslationPhrase))
      console.log("winLimitTranslationPhrase undefined in autoplayController");
    if (checkForUndefined(this.insufficientCreditTranslationPhrase))
      console.log(
        "insufficientCreditTranslationPhrase undefined in autoplayController"
      );
    if (checkForUndefined(this.defaultTranslationPhrase))
      console.log("defaultTranslationPhrase undefined in autoplayController");
  };

  this.showPopup = function () {
    autoplayManager.openDialog(this.start, this.cancel);
    messageBus.post("game:modal", { reason: "autoplay" });
  };
  this.hidePopup = function () {
    if (
      autoplayManager.dialog.container.alpha >= 1 &&
      autoplayManager.dialog.container.visible
    ) {
      autoplayManager.onCancel();
      messageBus.post("game:modal", {});
    }
  };

  this.start = function () {
    //A value less than 0 is interpreted as infinite autoplays
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : "X";

    resourceManager
      .getController("inputOverlord")
      .setTranslationParameters("autoplayButton", spinsRemainingStr);
    resourceManager
      .getController("inputOverlord")
      .setTranslationParameters("autoplayCancelButton", spinsRemainingStr);
    messageBus.post("game:modal", {});
    messageBus.post("autoplay:started", { spins: spinsRemaining });
    gameController.startGame();
  };

  this.cancel = function () {
    resourceManager
      .getController("inputOverlord")
      .setTranslationParameters("autoplayButton", "");
    resourceManager
      .getController("inputOverlord")
      .enableButton("autoplayButton");
    resourceManager
      .getController("inputOverlord")
      .setTranslationParameters("autoplayCancelButton", "");
    resourceManager
      .getController("inputOverlord")
      .disableButton("autoplayCancelButton");

    var remainingSpins = autoplayManager.getRemainingRounds();
    if (autoplayManager.isAutoplayEnabled()) {
      autoplayManager.stopAutoplay();
    } else {
      messageBus.post("game:modal", {});
    }

    messageBus.post("autoplay:ended", { spins: remainingSpins });
  };

  this.checkLimits = function () {
    var result = autoplayManager.canContinue();
    if (result.reason !== undefined) {
      autoplayManager.stopAutoplay();
      _limitPopupOpen = true;

      this.cancel();

      switch (result.reason) {
        case "EXPIRED": {
          _limitPopupOpen = false;
          break;
        }
        case "LOSS_LIMIT": {
          okBox.showPopup(
            this.lossLimitTranslationPhrase,
            this.checkLimitsPopupClosed
          );
          break;
        }
        case "WIN_LIMIT": {
          okBox.showPopup(
            this.winLimitTranslationPhrase,
            this.checkLimitsPopupClosed
          );
          break;
        }
        case "INSUFFICIENT_CREDIT": {
          okBox.showPopup(
            this.insufficientCreditTranslationPhrase,
            this.checkLimitsPopupClosed
          );
          break;
        }
        default: {
          okBox.showPopup(
            this.defaultTranslationPhrase,
            this.checkLimitsPopupClosed
          );
          break;
        }
      }
    }

    return _limitPopupOpen;
  };

  this.checkLimitsPopupClosed = function () {
    _limitPopupOpen = false;
  };

  this.readyToStart = function () {
    _readyToStart = true;
  };

  this.spinStarted = function (spinTask) {
    _readyToStart = false;
  };

  Object.defineProperty(this, "LimitPopupOpen", {
    get: function () {
      return _limitPopupOpen;
    },
  });
  Object.defineProperty(this, "Enabled", {
    get: function () {
      return autoplayManager.isAutoplayEnabled() && !_readyToStart;
    },
  });

  messageBus.subscribe("common:ReadyToStart", this.readyToStart);
  messageBus.subscribe("spinner:SpinEvent", this.spinStarted);
  messageBus.subscribe("common:PromotionEnded", this.cancel);
  messageBus.subscribe("common:AbortGame", this.cancel);
};

resourceManager.registerController("autoplayController", function () {
  return new autoplayController();
});
